export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&
// module id = null
// module chunks = 